export const mailContent = () =>
  `Hierbij nodig ik je van harte uit namens {organisation.name} om de reflector
 {survey.name} in te vullen. Je kunt vanaf nu met je e-mailadres en de eerder
 toegestuurde toegangscode op ieder moment inloggen in de Slow reflector app. Antwoorden 
 worden tussentijds opgeslagen.<br>
<br>
De deadline voor het invullen is {invite.deadline}.<br>`;
